const ANIMATION_TIME_SECONDS = 0.7;
const ANIMATION_TIME_MILLISECONDS = 700;
const REMOVE_TOAST_TIME_MILLISECONDS = 10000;

export { ANIMATION_TIME_MILLISECONDS, ANIMATION_TIME_SECONDS, REMOVE_TOAST_TIME_MILLISECONDS };
